import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetDocumentListEffect } from './get-document-list.effect';
import { getDocumentListReducer } from './get-document-list.reducer';
import { GET_DOCUMENT_LIST_STORE_NAME, GetDocumentListState } from './get-document-list.state';

/** Token of the GetDocumentList reducer */
export const GET_DOCUMENT_LIST_REDUCER_TOKEN = new InjectionToken<ActionReducer<GetDocumentListState, Action>>(
  'Feature GetDocumentList Reducer'
);

/** Provide default reducer for GetDocumentList store */
export function getDefaultGetDocumentListReducer() {
  return getDocumentListReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_DOCUMENT_LIST_STORE_NAME, GET_DOCUMENT_LIST_REDUCER_TOKEN),
    EffectsModule.forFeature([GetDocumentListEffect]),
  ],
  providers: [{ provide: GET_DOCUMENT_LIST_REDUCER_TOKEN, useFactory: getDefaultGetDocumentListReducer }],
})
export class GetDocumentListStoreModule {
  public static forRoot<T extends GetDocumentListState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetDocumentListStoreModule> {
    return {
      ngModule: GetDocumentListStoreModule,
      providers: [{ provide: GET_DOCUMENT_LIST_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
